import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=18fbcfe4&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fbcfe4",
  null
  
)

export default component.exports